import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Avatar, Box, ButtonBase, Typography } from '@material-ui/core';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';

// assets
import { IconMenu2 } from '@tabler/icons';

// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: 'rgba(255, 255, 255, 0.2)',
        color: '#ffffff',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.3)',
            color: '#ffffff'
        }
    },
    boxContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    },
    welcomeText: {
        fontWeight: 500,
        color: theme.palette.grey[700],
        fontSize: '0.95rem',
    }
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.boxContainer}>
                <Typography className={classes.welcomeText} sx={{ display: { xs: 'none', sm: 'block' } }}>
                    Welcome back
                </Typography>
            </div>
            <div className={classes.grow} />
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
